import { questionTypes } from '@/enums';
import Vacancy from '@/orm/models/Vacancy/Vacancy';
import { safeGet } from '@/functions';

export function prepareQuestions(questions) {
  return questions.map((q, i) => {
    if (q.type === questionTypes.VIDEO) {
      return { id: q.id, type: q.type, order: i + 1 };
    }

    if (typeof q.id === 'string') {
      return { type: q.type, question: q.question, order: i + 1 };
    }

    return {
      id: q.id,
      type: q.type,
      question: q.question,
      order: i + 1,
    };
  });
}

export async function getVacancyScript(vacancyId) {
  await Vacancy.api().fetchById(vacancyId);
  const vacancy = Vacancy.query().withAllRecursive().find(vacancyId);
  return safeGet(vacancy, ['script'], {});
}

export function extractQuestions(category) {
  return category.children ? [
    ...(category.questions || []),
    ...category.children.flatMap(extractQuestions),
  ] : [...(category.questions || [])];
}
